import React from "react";
import { useNavigate } from "react-router-dom";
import { useList } from "@refinedev/core";
import { VaultSidebar, VaultDocItem } from "@/components/digibox/VaultSidebar";

function mapAcceptanceStatus(status?: string): VaultDocItem["status"] {
  if (!status || status === "Pending") return "action";
  if (status === "Final Acceptance" || status === "Accepted") return "accepted";
  if (status === "Read") return "read";
  return "pending";
}

export const AcceptanceList: React.FC = () => {
  const navigate = useNavigate();

  const { data, isLoading } = useList({
    resource: "acceptance",
    pagination: { pageSize: 50 },
    sorters: [{ field: "acclastdate", order: "desc" }],
  });

  const tasks = (data?.data || []) as any[];
  const pending = tasks.filter(
    (t) => t.acceptance_status === "Pending" || !t.acceptance_status
  );
  const completed = tasks.filter(
    (t) =>
      t.acceptance_status === "Final Acceptance" ||
      t.acceptance_status === "Accepted" ||
      t.acceptance_status === "Read"
  );

  const documents: VaultDocItem[] = tasks.map((t: any) => ({
    id: t.id,
    category: t.accmethod || "Task",
    title: t.acctitle || "Untitled Task",
    date: t.acclastdate
      ? new Date(t.acclastdate).toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        })
      : "—",
    status: mapAcceptanceStatus(t.acceptance_status),
  }));

  const handleSelect = (id: string) => {
    navigate(`/digibox/acceptance/${id}`);
  };

  return (
    <>
      <VaultSidebar
        documents={documents}
        onSelect={handleSelect}
        loading={isLoading}
      />

      <main className="vault-panel vault-main-content">
        <div className="vault-hub-content">
          <div className="vault-hub-hero">
            <h1 className="vault-heading-display">ACCETTAZIONI</h1>
          </div>

          <div className="vault-hub-stats">
            <div className="vault-hub-stat">
              <span className="vault-label-tiny">In Attesa</span>
              <span className="vault-hub-stat-value">{pending.length}</span>
            </div>
            <div className="vault-hub-stat">
              <span className="vault-label-tiny">Completate</span>
              <span className="vault-hub-stat-value">{completed.length}</span>
            </div>
            <div className="vault-hub-stat">
              <span className="vault-label-tiny">Totale</span>
              <span className="vault-hub-stat-value">{tasks.length}</span>
            </div>
          </div>

          <div style={{ marginTop: "var(--vault-spacing-md)" }}>
            <p
              className="vault-text-body-editorial"
              style={{ color: "var(--vault-fg-muted)" }}
            >
              Seleziona un&apos;accettazione dalla barra laterale per
              visualizzare i dettagli e completare l&apos;azione richiesta.
            </p>
          </div>
        </div>
      </main>
    </>
  );
};
